module.exports = __webpack_public_path__ + "assets/ProfissionalEspecializacao.7390961c3b5e3fcd35c200ab0472d272.png";


/*****************
 ** WEBPACK FOOTER
 ** ./public/img/legenda/ProfissionalEspecializacao.png
 ** module id = 481
 ** module chunks = 0
 **/